/**************************
 * Administration events  *
 **************************/

$('body').on('click', '#impersonate-user-search', function (e) {
    let searchString = $('#impersonate-user-search-string').val();

    $.ajax({
        method: 'POST',
        url: '/findImpersonateUsers',
        data: {'searchString': searchString},
        success: function (users) {
            $('#impersonate-user-id').empty();

            if (users.length == 0) {
                let option = '<option value="">No user(s) found, user other search criteria</option>';

                $('#impersonate-user-id').append(option);
                $('#impersonate-user-id').prop('disabled', true);
            } else {
                $.each(users, function (index, user) {
                    let option = '<option value="{userId}">{userFullName} ({username}) - {email}</option>';
                    option = option.replace('{userId}', user.id);
                    option = option.replace('{userFullName}', user.fullName);
                    option = option.replace('{username}', user.username);
                    option = option.replace('{email}', user.email);

                    $('#impersonate-user-id').append(option);
                    $('#impersonate-user-id').prop('disabled', false);
                });

                $('#impersonate-button').prop('disabled', false);
            }

            iris.unsetButtonLoadingByReference('#impersonate-user-search');
        },
        error: function (response, status, error) {
            console.log(response, status, error);
            iris.unsetButtonLoadingByReference('#impersonate-user-search');
        }
    });
});

$('body').on('click', '#impersonate-button', function (e) {
    $('#impersonate-form').submit();
});

$('body').on('click', '#service-modify-button', function (e) {
    $('#service-modify-form').submit();
});

$('body').on('click', '#service-upload-pricelist-button', function (e) {
    $('#service-upload-pricelist-form').submit();
});

$('body').on('click', '#service-add-button', function (e) {
    $('#service-add-form').submit();
});

/************************
 * log.blade.php events *
 ************************/

$('body').on('click', '.table-container tr', function (e) {
    $('#' + $(this).data('display')).toggle();
});

$('#table-log').DataTable({
    "order": [1, 'desc'],
    "stateSave": true,
    "stateSaveCallback": function (settings, data) {
        window.localStorage.setItem("datatable", JSON.stringify(data));
    },
    "stateLoadCallback": function (settings) {
        let data = JSON.parse(window.localStorage.getItem("datatable"));
        if (data) data.start = 0;
        return data;
    }
});

$('body').on('click', '#delete-all-log', function (e) {
    return confirm('Are you sure?');
});

$('body').on('click', '#delete-log', function (e) {
    return confirm('Are you sure?');
});

$('body').on('click', '#service-retire-button', function (e) {
    if (confirm('Are you sure want to retire this service? This cannot be undone.')) {
        $('#State').val('Retired');
        $('#service-modify-form').submit();
    }
});

$('body').on('click', '#porfolio-image-update', function (e) {
    $('#porfolio-image-update-form').submit();
});

$('body').on('click', '#reconciliation-upload', function (e) {
    $('#reconciliation-upload-form').submit();
});

$('body').on('click', '#document-upload', function (e) {
    $('#document-upload-form').submit();
});

$('body').on('click', '#submit-creditdebit-form', function (e) {
    $('#creditdebit-form').submit();
});

$('body').on('click', '#review-creditdebit-form', function (e) {
    $('#creditdebit-form').submit();
});

$('body').on('click', '#update-creditdebit-approval', function (e) {
    $('#creditdebit-update-form').submit();
});

$('body').on('click', '.sm_delete_document', function () {
    var documentId = $(this).data('document-id');
    var serviceId = $(this).data('service-id');
    var documentForm = $('#document_form');

    documentForm.attr('action', '/admin/marketing-sales/services/' + serviceId + '/documents/' + documentId);
    documentForm.find('input[name=_method]').attr('value', 'DELETE');
    documentForm.submit();
});

